import { ProductSlugVersion } from '../repositories/products'

export interface UrlParams {
  chosenProducts: ProductSlugVersion[]
}

// A shared link is user-editable text, so a payload can decode cleanly and still
// be nothing we can use. Callers only handle null, so anything off-shape becomes null
// here rather than reaching them as a UrlParams that lies about its own type.
function isUrlParams(params: any): params is UrlParams {
  return typeof params === 'object' &&
    params !== null &&
    Array.isArray(params.chosenProducts) &&
    params.chosenProducts.every((product: any) =>
      typeof product === 'object' && product !== null && typeof product.slug === 'string'
    )
}

function decodeUrlParams(encodedParams: string): UrlParams | null {
  let params

  try {
    params = JSON.parse(
      atob(
        encodedParams
      )
    )
  } catch (err) {
    return null
  }

  return isUrlParams(params) ? params : null
}

function encodeUrlParams(urlParams: UrlParams): string {
  return btoa(
    JSON.stringify(
      urlParams
    )
  )
}

function newUrlParams(newParams: UrlParams): UrlParams {
  let fullParams: UrlParams = {chosenProducts: []}

  if (newParams.chosenProducts) {
    for (const chosenProduct of newParams.chosenProducts) {
      fullParams.chosenProducts.push({
        slug: chosenProduct.slug,
        current: chosenProduct.current,
        target: chosenProduct.target
      })
    }
  }

  return fullParams
}

export function updateUrlParamsAndCopyToClipboard(params: UrlParams) {
  let newParams = newUrlParams(params)

  window.history.pushState(null, "", encodeUrlParams(newParams))
  navigator.clipboard.writeText(window.location.href)
}

// Distinguishes "someone opened a shared link" from "someone opened the site".
// Both end up with no restored products when the link is unusable, but only the
// first one should be told that a link failed.
export function hasSharedLinkPath(): boolean {
  return window.location.pathname !== '/'
}

export function loadUrlParams(): UrlParams | null {
  if (!hasSharedLinkPath()) {
    return null
  }
  let params = window.location.pathname
  if (params[0] === '/') {
    params = params.slice(1)
  }
  return decodeUrlParams(params)
}
